// List of white label IDs where Intercom launcher and features should be hidden
export const HIDDEN_INTERCOM_WHITE_LABELS = [
  "supreme",
  "rab2b",
  // Add more white label IDs here
];
